<template>
    <div>
        <div class="modal-content modal-content-secondary">
            <h3 class="stack-m">Payment Instrument</h3>
            <div class="tile">
                <div class="tile-content position-relative">
                    <v-inline-loader v-if="isSwitching"/>
                    <v-payment-instrument :instrument="paymentInstrument" />
                </div>
            </div>
        </div>
        <div class="modal-content" v-if="paymentInstruments.length > 1">
            <r-button size="small" @click="showMoreInstruments" :class="{'stack-m': showInstruments}">Change payment instrument</r-button>
            <template v-if="showInstruments">
                <template v-for="(instrument, index) in paymentInstruments">
                    <div :class="{'stack-m': index !== paymentInstruments.length - 1}" v-if="instrument.id !== paymentInstrument.id">
                        <v-payment-instrument class="stack-s" :instrument="instrument" is-compact/>
                        <r-button size="small" @click="changeInstrument(instrument)">Select</r-button>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import vPaymentInstrument from '@/components/payment-instrument/v-payment-instrument';
    import vInlineLoader from '@/components/v-inline-loader';

    export default {
        components: {
            vPaymentInstrument,
            vInlineLoader,
        },
        props: {
            isSwitching: Boolean,
            showInstruments: Boolean,
            paymentInstrument: {
                type: Object,
                required: true,
            },
            paymentInstruments: {
                type: Array,
                required: true,
            },
        },
        methods: {
            changeInstrument(instrument) {
                this.$emit('change-instrument', instrument);
            },
            showMoreInstruments() {
                this.$emit('show-instruments', !this.otherInstruments);
            },
        },
    };
</script>
